import { NgModule, ModuleWithProviders } from '@angular/core';

import { ProcessingService, PROCESSING_CONFIG } from '@relevance/angular-core';

import { UtilitiesModuleConfig, UTILS_CONFIG } from './utils.config';
import { GeolocationService } from './geo.service';

@NgModule()
export class UtilitiesModule {

  static forRoot(config: UtilitiesModuleConfig): ModuleWithProviders<UtilitiesModule> {
    return {
      ngModule: UtilitiesModule,
      providers: [
        ProcessingService,
        GeolocationService,
        {
          provide: UTILS_CONFIG,
          useValue: config,
        },
        {
          provide: PROCESSING_CONFIG,
          useValue: config.processingConfig || {},
        },
      ],
    };
  }

  static forChild(config: UtilitiesModuleConfig): ModuleWithProviders<UtilitiesModule> {
    return UtilitiesModule.forRoot(config);
  }

}
